<template>
  <div id="gamePhase">
    <Timer :roundStartTime="phase.roundStartTime" />
    <!-- <div class="title">GAMEPHASE</div> -->
    <div class="holder">
      <div class="row flex">
        <div class="name">1<sup>st</sup> Rd</div>
        <!-- <div class="flex">
          <label>
            <input type="checkbox" v-model="rounds.sample.popUp" />
            PopUp</label
          >
        </div> -->
        <div class="flex">
          <label>
            <input
              type="checkbox"
              v-model="rounds.sample.start"
              @click="initTimer"
            />Start
          </label>
        </div>
        <!-- <div class="flex">
          <label>
            <input type="checkbox" v-model="rounds.sample.end" />End</label
          >
        </div> -->
      </div>

      <div class="row flex">
        <div class="name">2<sup>nd</sup> Rd</div>
        <!-- <div class="flex">
          <label
            ><input type="checkbox" v-model="rounds.first.popUp" />PopUp</label
          >
        </div> -->
        <div class="flex">
          <label @click="setResetOpen"
            ><input
              type="checkbox"
              v-model="rounds.first.start"
              @click="initTimer"
            />Start</label
          >
        </div>
        <div class="flex">
          <label><input type="checkbox" v-model="rounds.first.end" />End</label>
        </div>
      </div>

      <div class="row flex">
        <div class="name">3<sup>rd</sup> Rd</div>
        <!-- <div class="flex">
          <label
            ><input type="checkbox" v-model="rounds.second.popUp" />PopUp</label
          >
        </div> -->
        <div class="flex">
          <label @click="setResetOpen"
            ><input
              type="checkbox"
              v-model="rounds.second.start"
              @click="initTimer"
            />Start</label
          >
        </div>
        <div class="flex">
          <label
            ><input type="checkbox" v-model="rounds.second.end" />End</label
          >
        </div>
        <div class="flex">
          <label
            ><input type="checkbox" v-model="rounds.second.yeah" />Yeah</label
          >
        </div>
      </div>

      <div class="row flex">
        <div class="name">3<sup>rd</sup> Rd</div>
        <div class="flex">
          <label
            >Obj_x
            <input
              class="hackInput bigger_width"
              type="number"
              v-model="rounds.second.obj2x_alt"
            />
          </label>
        </div>
      </div>

      <div class="row flex">
        <div class="name">Hack</div>
        <!-- <div class="flex">
          <label>
            <input type="checkbox" v-model="rounds.hack.start" />Start</label
          >
        </div> -->
        <div class="flex">
          <label
            >hack:
            <input
              class="hackInput"
              type="number"
              v-model="rounds.hack.toHack"
            />
          </label>
        </div>
        <div class="flex">
          <label
            >unhack:
            <input
              class="hackInput"
              type="number"
              v-model="rounds.hack.unHack"
            />
          </label>
        </div>
        <!-- <div class="flex">
          <label> <input type="checkbox" v-model="rounds.hack.end" />End</label>
        </div> -->
      </div>

      <div class="row flex">
        <div class="name">FW</div>
        <div class="flex">
          <label>
            <input type="checkbox" v-model="rounds.firewall.show" />Show</label
          >
        </div>

        <div class="flex">
          <label>
            <input
              type="checkbox"
              v-model="rounds.firewall.editable"
            />Edit</label
          >
        </div>
      </div>

      <div class="row flex">
        <div class="name">Barqul:</div>
        <div class="flex">
          <label>
            <input
              type="radio"
              id="one"
              value="on"
              v-model="rounds.hack.barqul"
            />
            on
          </label>
        </div>
        <div class="flex">
          <label>
            <input
              type="radio"
              id="one"
              value="off"
              v-model="rounds.hack.barqul"
            />
            off</label
          >
        </div>
      </div>
    </div>

    <button class="confirm pointer" @click="confirm">Confirm</button>
    <!-- <div class="notes">
      <textarea
        name="notes"
        id=""
        cols="30"
        rows="10"
        v-model="notes"
      ></textarea>
    </div> -->
    <div class="notes">
      <p>
        SAM#001: 4,B,D;  2: BC,L,7;  3:04,15,R,E;
        4: 3,8,O  5: 19,Pod  6: 7,16,H,Mas;<br>7: 30,47,A,BA;
        8: A,R,E,ALV  9: 6,D,C,Msk;  10: 03,15,Y,BR;
        11: AB,M,Rg<br>12: 3,I,U,Brn;
        A4 2CUB;  A8 Maddie;  A10 Boss;  A9 >100K; 
        A14 3MAZ;  A14 Price;  A17 BubCub-20%;  B1 BUB-5';
        B3 Ergo;  B5 Freeze;  B7 MessgMissg;  B9 Freezout;
        B10 SuperCerts;  B11 2MAN;  B12 Audit;  B12 Jason;
        B13 HOM;  B15 PW;  B17 2MAN!
      </p>
      <!-- <p>
        SAM#001: 4,B,D 2: BC,L,7 3: 04A 15C,R,E<br />
        4: 3,8,O, Ld 5: 19,Pod 6: 7,16,H,Mas<br />
        7: 30,47,A,BA 8: A,R,E,ALV 9: 6,D,C,Msk<br />
        10: 03C,15D,Y,BR 11: AB,M,Rg 12: 3,I,U,Brn<br />
        A4 2CUB; A9 100k; A14 3Maz; A17 -20CuBub<br />
        B1 -Bub; B5 Freeze; B9 lifted; B11 2Man<br />
        B13 Hom; B15 PW; B17 Man? R90 3Maz<br />
        R91 Grds<br />
        <br />
        Note: Emma =>? Aisha =>?
      </p> -->
    </div>
  </div>
</template>

<script>
import Timer from "./Timer.vue";
export default {
  name: "Gamephase",
  components: { Timer },
  props: {
    phase: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["playerSpecificData", "msg"],
  data() {
    return {
      rounds: this.phase,
      notes: "",
      needtoReset: false,
      roundStartTime: {},
      // rounds: {},
    };
  },
  watch: {
    phase: function (newVal) {
      console.log("PHASE WATCHER!!!!!!!!");
      this.rounds = newVal;
    },
  },

  methods: {
    initTimer() {
      this.roundStartTime = new Date();
    },
    // isNewPhase(before, after) {
    //   if (
    //     (before.first.start == false && after.first.start == true) ||
    //     (before.second.start == false && after.second.start == true)
    //   ) {
    //     return true;
    //   }
    //   return false;
    // },
    setResetOpen() {
      this.rounds.resetOpen = true;
    },
    setPhase() {
      let spielPhase = -1;
      if (this.rounds.sample.start) {
        spielPhase = 0;
      }
      for (const i in this.rounds.first) {
        console.log(this.rounds.first[i]);
        if (this.rounds.first[i]) {
          spielPhase = 1;
          break;
        }
      }
      for (const i in this.rounds.second) {
        if (this.rounds.second[i]) {
          spielPhase = 2;
          break;
        }
      }
      for (const i in this.rounds.hack) {
        if (this.rounds.hack[i] && i != "barqul") {
          spielPhase = 3;
          break;
        }
      }

      this.rounds.phase = spielPhase;
    },
    confirm() {
      console.log(this.needtoReset);
      if (this.needtoReset) {
        this.rounds.resetOpen = false;
        this.needtoReset = false;
      }
      // if (this.coolDown()) return false;
      console.log(this.rounds);
      console.log(this.rounds.resetOpen);
      this.setPhase();
      this.$emit("msg", "a new gamephase is about to begin!");
      console.log("update gamePhase");

      let gamePhaseToSend = { ...this.rounds };
      console.log(this.roundStartTime);
      gamePhaseToSend.roundStartTime = this.roundStartTime;
      console.log(gamePhaseToSend);

      let data = {
        id: Date.now(), //time
        rawData: JSON.parse(JSON.stringify(gamePhaseToSend)),
        // notes: this.notes,
        name: "GM",
        type: "gamePhase",
      };
      console.log(data.rawData.hack.toHack);
      this.$emit("playerSpecificData", data);
      this.rounds.hack.toHack = "";
      this.rounds.hack.unHack = "";
      this.rounds.needtoReset = true;
    },
  },
  created() {
    if (!this.rounds) console.log("ROUNDS");
    this.rounds = {
      phase: 0,
      sample: {
        //0
        start: false,
      },
      first: {
        //1
        start: false,
        end: false,
      },
      second: {
        //2
        start: false,
        end: false,
        yeah: false,
        obj2x_alt: 0,
      },
      hack: {
        //3
        toHack: 0,
        unHack: 0,
        barqul: "on",
      },
      firewall: {
        show: false,
        editable: true,
      },
      resetOpen: false,
      sampleRevenueSet: false,
      secondRoundRevenueSet: false,
    };
  },
};
</script>

<style scoped>
.notes {
  font-size: 16px;
  margin: -5px -11px;
  line-height: 20px;
}

.name {
  flex-basis: 200px;
}

.confirm {
  height: 42px;
  border: 3px solid #214a7c;
  background: white;
  color: #214a7c;
  width: 100%;
  margin-top: 20px;
  font-size: 19px;
}

.confirm:hover {
  cursor: pointer;
  border: 3px solid white;
  background: #214a7c;
  color: white;
}

input[type="checkbox"],
input[type="radio"] {
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="checkbox"]:checked,
input[type="radio"]:checked {
  background-color: #28f528;
  border: 2px solid white;
}

#gamePhase {
  width: 29%;
  border: 1px solid black;
  font-size: 18px;
  padding: 0 14px;
}

.hackInput {
  width: 36px;
  padding: 5px;
  margin-left: 5px;
  border: 0px;
  font-size: 19px;
}

.bigger_width {
  width: 100px;
}

.title {
  text-align: center;
}

label {
  display: flex;
  align-items: center;
}

.row > div {
  flex: 1;
}

.flex {
  margin: 5px;
  display: flex;
  align-items: center;
}

label:hover {
  cursor: pointer;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
